import styled from 'styled-components';
import { SCREEN } from '../../assets/styles/constants';

export const Divider = {};

Divider.VerticalDivider = styled.span`
	width: ${props => (props.width ? `${props.width}px` : '')};
`;

Divider.Line = styled.div`
	width: 100%;
	height: 40px;
`;

Divider.SmallMarginDivider = styled(Divider.Line)`
	height: 10px;
`;

Divider.MarginDivider = styled(Divider.Line)`
	height: 20px;
`;

Divider.MediumMarginDivider = styled(Divider.Line)`
	height: 30px;
`;

Divider.BigMarginDivider = styled(Divider.Line)`
	height: 40px;
`;

export const GrayUnderline = styled.div`
	align-self: flex-start;
	width: 200px;
	height: 7px;
	background: #dbdbdb;
	margin: 30px 0 70px 0;
	border-radius: 1px;

	${SCREEN.MEDIUM} {
		height: 4px;
		margin: 20px 0px 40px 0px;
		width: 100%;
	}
`;

export const Spacing = styled(Divider.Line)`
	height: 70px;
	${props => (props.mobile ? 'display: none' : '')};
	
	${SCREEN.MEDIUM} {
		height: 45px;
		${props => (props.small ? 'height: 10px;' : '')};
		${props => (props.medium ? 'height: 25px;' : '')};
		${props => (props.mobile ? 'display: block' : '')};
		${props => (props.desktop ? 'display: none' : '')};
	}
`;

export const LineBreak = styled.br`
	${SCREEN.MEDIUM} {
		${props => (props.nomobile ? 'display: none' : '')};
	}
`;

export const LineDivider = styled.div`
	width: 100%;
	margin: 35px 0;
	border-bottom: solid 1px rgb(53, 57, 68, .3);
`;
